import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import IconAdd from '../../assets/icon_add.svg';
import IconLaunch from '../../assets/icon_launch.svg';
import IconMenu from '../../assets/icon_menu.svg';
import tutorialImg from '../../assets/shape.png';

import {
  TXTWCL_Click_on_add_to_FavoriteX,
  TXTWCL_Go_to_the_left_MenuX,
  TXTWCL_Launch_any_GameX,
  TXTWCL_Look_for_the_N0_symbol_on_any__ELL,
  TXTWCL_You_can_now_add_games_to_your__ELL
} from './NoAvailableFavorites.messages.json';
import styles from './NoAvailableFavorites.scss';
import TutorialItem from './TutorialItem';

const NoAvailableFavorites: React.FC = () => (
  <section className={classNames(styles.tutorialBox)}>
    <div className={styles.largeView}>
      <div className={classNames(styles.header)}>
        <Translation {...TXTWCL_Click_on_add_to_FavoriteX} />
      </div>
      <div className={classNames(styles.subHeader)}>
        <Translation
          {...TXTWCL_Look_for_the_N0_symbol_on_any__ELL}
          values={{
            0: <img src={tutorialImg} alt="" />
          }}
        />
      </div>
    </div>
    <div className={styles.smallView}>
      <div className={classNames(styles.mobileHeader)}>
        <Translation {...TXTWCL_You_can_now_add_games_to_your__ELL} />
      </div>
      <div className={classNames(styles.boxContainer)}>
        <TutorialItem icon={<IconLaunch />} text={{ ...TXTWCL_Launch_any_GameX }} />
        <TutorialItem icon={<IconMenu />} text={{ ...TXTWCL_Go_to_the_left_MenuX }} />
        <TutorialItem icon={<IconAdd />} text={{ ...TXTWCL_Click_on_add_to_FavoriteX }} />
      </div>
    </div>
  </section>
);

export default NoAvailableFavorites;
